import { gql } from '@apollo/client';
import { authClient } from './client';


interface AuthResponse {
  status: number;
  message: string;
  token?: string;
  data?: {
    usertype?: string | null;
    role?: string | null;
    isAdmin?: boolean;
    _id: string;
    name: string;
    email: string;
    phone: string;
  };
}

export const signup = async (userData: {
  name: string;
  email: string;
  phone: string;
  password: string;
}): Promise<AuthResponse> => {
  const SIGNUP_MUTATION = gql`
    mutation Signup($input: PyUserInput!) {
      signup(input: $input) {
        status
        message
     
     data {
          _id
          name
          email
          phone
          
        }
        token
      }
    }
  `;

  try {
    const { data } = await  authClient.mutate({
      mutation: SIGNUP_MUTATION,
      variables: {
        input: {
          name: userData.name,
          email: userData.email,
          phone: userData.phone,
          password: userData.password
        }
      },
    });
    
    if (data.signup.status === 200) {
      localStorage.setItem('AUTH_TOKEN', data.signup.token);
      localStorage.setItem('userData', JSON.stringify(data.signup.data));
    }
    
    return data.signup;
  } catch (error: unknown) {
    let errorMessage = 'Failed to sign up';
    
    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    console.error('Signup error:', errorMessage);
    return {
      status: 500,
      message: errorMessage,
    };
  }
};

export const getCurrentUser = async (): Promise<AuthResponse> => {
  const ME_QUERY = gql`
    query Me {
      me {
        status
        message
        data {
          _id
          email
          name
          usertypeId
          usertype
          role
          isAdmin
          phone
        }
      }
    }
  `;

  try {
    const { data } = await authClient.query({
      query: ME_QUERY,
      fetchPolicy: 'network-only',
    });

    return data.me;
  } catch (error: unknown) {
    let errorMessage = 'Failed to fetch current user';

    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    console.error('getCurrentUser error:', errorMessage);
    return {
      status: 500,
      message: errorMessage,
    };
  }
};

export const login = async (credentials: {
  email: string;
  password: string;
}): Promise<AuthResponse> => {
  const LOGIN_MUTATION = gql`
    mutation Login($email: String!, $password: String!) {
      login(email: $email, password: $password) {
        status
        message
        
        data {
             _id
          email
           name
            usertypeId
          usertype
          phone
        }
        token
      }
    }
  `;

  try {
    const { data } = await  authClient.mutate({
      mutation: LOGIN_MUTATION,
      variables: {
        email: credentials.email,
        password: credentials.password
      },
    });
    
    if (data.login.status === 200) {
      
      localStorage.setItem('AUTH_TOKEN', data.login.token);
      localStorage.setItem('userData', JSON.stringify(data.login.data));
    }
    
    return data.login;
  } catch (error: unknown) {
    let errorMessage = 'Failed to login';
    
    if (error instanceof Error) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    console.error('Login error:', errorMessage);
    return {
      status: 500,
      message: errorMessage,
    };
  }
};
